export enum PROJECT_TYPE {
    OPERATION = '4',
    EXPENDITURE = '1',
    SALES = '2',
    ASSET_MANAGEMENT = '3',
}

// Opsi untuk select
export const PROJECT_TYPE_OPTIONS = [
    { value: PROJECT_TYPE.OPERATION, label: 'OPERATION' },
    { value: PROJECT_TYPE.EXPENDITURE, label: 'EXPENDITURE' },
    { value: PROJECT_TYPE.SALES, label: 'SALES' },
    { value: PROJECT_TYPE.ASSET_MANAGEMENT, label: 'ASSET MANAGEMENT' },
];

// = untuk menampilkan label dari value
export const getProjectTypeLabel = (value: string): string => {
    const found = PROJECT_TYPE_OPTIONS.find((opt) => opt.value === value);
    return found ? found.label : 'Unknown';
};


export enum PROJECT_STATUS {
    PENDING = '1',
    IN_PROGRESS = '2',
    HOLD = '3',
    COMPLETE = '4',
    CLOSE_BY_ADMIN = '5'
}

export const PROJECT_STATUS_OPTIONS = [
    { value: PROJECT_STATUS.PENDING, label: 'PENDING' },
    { value: PROJECT_STATUS.IN_PROGRESS, label: 'IN PROGRESS' },
    { value: PROJECT_STATUS.HOLD, label: 'HOLD' },
    { value: PROJECT_STATUS.COMPLETE, label: 'COMPLETE' },
    { value: PROJECT_STATUS.CLOSE_BY_ADMIN, label: 'CLOSE BY ADMIN' },
];

export const getProjectStatusLabel = (value: string): string => {
    const found = PROJECT_STATUS_OPTIONS.find((opt) => opt.value === value);
    return found ? found.label : 'Unknown';
};


export enum APPROVE_STATUS {
    PENDING = '1',
    CEK = '2',
    REJECT = '3',
    APPROVED = '4',
}

export const APPROVE_STATUS_OPTIONS = [
    { value: APPROVE_STATUS.PENDING, label: 'PENDING' },
    { value: APPROVE_STATUS.CEK, label: 'CEK' },
    { value: APPROVE_STATUS.REJECT, label: 'REJECT' },
    { value: APPROVE_STATUS.APPROVED, label: 'APPROVED' },
];

export const getApprovalStatusLabel = (value: string): string => {
    const found = APPROVE_STATUS_OPTIONS.find((opt) => opt.value === value);
    return found ? found.label : 'Unknown';
};


